export const dictionaryTableQuantitatives = {
  PorticosTravamentos: {
    label: 'Pórticos e travamentos',
    quant: [
      {
        item: {
          label: 'Item',
        },
        material: {
          label: 'Material',
        },
        peso_por_metro: {
          label: 'Peso linear',
          typeValue: 'Kg/m',
          fractionDigits: 1,
        },
        comprimento: {
          label: 'Comprimento',
          typeValue: 'mm',
          fractionDigits: 0,
        },
        quantidade: {
          label: 'Quantidade',
          typeValue: '',
        },
        observacoes: {
          label: 'Observações',
          typeValue: '',
        },
        peso_total: {
          label: 'Peso total',
          typeValue: 'Kg',
          fractionDigits: 0,
        },
      },
    ],
    totais: [
      {
        peso_subtotal: {
          label: 'Subtotal:',
          typeValue: 'kg',
          fractionDigits: 0,
        },
        taxa: {
          label: 'Taxa:',
          typeValue: 'kg/m²',
          fractionDigits: 1,
        },
      },
    ],
  },
};
